// import * as signalR from "@microsoft/signalr";

// let connection = null;

// export const startNotificationConnection = async (onReceive) => {
//   connection = new signalR.HubConnectionBuilder()
//     .withUrl("http://192.168.5.60:5000/notificationHub", {
//       accessTokenFactory: () => localStorage.getItem("token"), // your JWT token
//     })
//     .withAutomaticReconnect()
//     .configureLogging(signalR.LogLevel.Information)
//     .build();

//   connection.on("ReceiveNotification", (message) => {
//     console.log("Received notification:", message);
//     if (onReceive) onReceive(message);
//   });

//   try {
//     await connection.start();
//     console.log("SignalR connected.");
//   } catch (err) {
//     console.error("SignalR Connection Error:", err);
//   }
// };

import * as signalR from "@microsoft/signalr";

let connection = null;

// signalR.js
export const startNotificationConnection = async (onAdminTrigger, onPoliceTrigger) => {
  connection = new signalR.HubConnectionBuilder()
    .withUrl("https://api.omnirep.online/notificationHub", {
      accessTokenFactory: () => localStorage.getItem("token"),
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  // Admin notification
  connection.on("AdminReportAdded", () => {
    console.log("🔥 AdminReportAdded received");
    if (onAdminTrigger) onAdminTrigger();
  });

  

  // Police notification
  connection.on("PoliceReportApproved", () => {
    console.log("🔥 PoliceReportApproved received");
    if (onPoliceTrigger) onPoliceTrigger();
  });

  try {
    await connection.start();
    console.log("SignalR connected.");
  } catch (err) {
    console.error("SignalR Connection Error:", err);
  }
};
